import { createFileRoute } from "@tanstack/react-router";
import AdminDocsPage from "@/admin/pages/docs";

export type AdminDocsSearch = {
  path?: string;
};

export const Route = createFileRoute("/admin/docs/")({
  component: AdminDocsPage,
  validateSearch: (search: Record<string, unknown>): AdminDocsSearch => ({
    path: typeof search.path === "string" ? search.path : undefined,
  }),
});
